"use client";

import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

const projectsList = [
  {
    title: "ISTD",
    description: "ISTD (Indian Society for Training & Development) – 1st Runner-Up",
    tech: ["Hackathon"],
    link: "",
    image: "/awards/istd.png",
    category: ""
  },
  {
    title: "VJTI College",
    description: "VJTI College Hackathon – Winner",
    tech: ["Hackathon"],
    link: "",
    image: "/awards/vjti.jpg",
    category: ""
  },
  {
    title: "Pillai College",
    description: "Pillai College Hackathon – 1st Runner-Up",
    tech: ["Hackathon"],
    link: "",
    image: "/awards/PCE.png",
    category: ""
  }
];

export default function Award() {
  const [activeTab, setActiveTab] = useState("All");

  const filteredProjects = activeTab === "All"
    ? projectsList
    : projectsList.filter(p => p.category === activeTab);

  return (
    <section id="awards" className="py-12 px-6 md:px-12 max-w-7xl mx-auto space-y-10 border-b border-slate-50">
      <div className="space-y-6">
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-slate-900">Awards & Recognitions</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[var(--accent-cyan)] to-[var(--accent-purple)] rounded-full"></div>
        </div>
      </div>

      <div className="">
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 min-h-[400px]"> */}
        {filteredProjects.map((project) => (
          <Link href={project.link} key={project.title} className="group h-full animate-fade-in mt-3">
            <div className="futuristic-card h-full flex items-start p-0 overflow-hidden border-slate-100 bg-white/50 hover:bg-white transition-all duration-500">
              <div className="relative w-25 h-25 overflow-hidden">
                <Image
                  src={project.image}
                  alt={project.title}
                  fill
                  className="object-cover transform group-hover:scale-110 transition w-70 h-70 duration-700 opacity-90 group-hover:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white/95 via-white/10 to-transparent"></div>
              </div>

              <div className="p-4 space-y-1 flex flex-col flex-grow">
                <div className="flex justify-between items-start">
                  <h3 className="text-sm md:text-lg font-bold text-slate-900  transition-colors leading-tight">
                    {project.title}
                  </h3>

                </div>
                <p className="text-slate-600 text-[10px] md:text-[13px] leading-relaxed flex-grow">
                  {project.description}
                </p>

                <div className="flex justify-between">
                  <div className="flex flex-wrap gap-1.5 border-t border-slate-100">
                    {project.tech.map((tag, tIndex) => (
                      <span key={tIndex} className="text-[6px] md:text-[9px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded bg-slate-50 text-slate-600 border border-slate-100">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
